<template>
  <div>
    <div v-if="!user.grant.validate">
      <div class="h-screen flex w-full bg-img">
          <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
              <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
              <h1 class="sm:mx-0 mx-4 mb-12 text-3xl d-theme-heading-color">404 - Page introuvable!</h1>
              <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">La page que vous demandez est introuvable</p>
          </div>
      </div>
    </div>
    <div class="vx-row" v-else>
    <div class="vx-col w-full lg:w-1/3">
      <vs-card>
        <div slot="header">
          <h5>Valider une consultation</h5>
        </div>
        <vs-row>
          <vs-col vs-w="12">
            <vs-input
            :danger="errors.code ? true : false"
            :danger-text="errors.code ? errors.code[0] : ''"
            v-model="form.code" class="w-full mb-1" label="Code de consultation"></vs-input>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="12">
            <vs-input
            :danger="errors.phone ? true : false"
            :danger-text="errors.phone ? errors.phone[0] : ''"
            v-model="form.phone" class="w-full mb-1" label="Numéro payeur"></vs-input>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="12">
            <vs-input
              :danger="errors.last_name ? true : false"
              :danger-text="errors.last_name ? errors.last_name[0] : ''"
              v-model="form.last_name" class="w-full mb-1" label="Nom"></vs-input>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="12">
            <vs-input
              :danger="errors.first_name ? true : false"
              :danger-text="errors.first_name ? errors.first_name[0] : ''"
              v-model="form.first_name" class="w-full mb-1" label="Prénom"></vs-input>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="12">
            <vs-select
            class="w-full mb-1"
            label="Type spécialité"
            icon="arrow_downward"
            v-model="form.type"
            :danger="errors.type ? true : false"
            :danger-text="errors.type ? errors.type[0] : ''"
            autocomplete
            @change="getSpecialities"
            >
              <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in types" />
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="12">
            <vs-select
            @change="changeSpeciality"
            class="w-full mb-1"
            label="Spécialité"
            icon="arrow_downward"
            v-model="form.speciality_id"
            :danger="errors.speciality_id ? true : false"
            :danger-text="errors.speciality_id ? errors.speciality_id[0] : ''"
            autocomplete
            >
              <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in specialities" />
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="12">
            <vs-select
            placeholder="Selectionner"
            class="w-full mb-1"
            label="Praticien"
            v-model="form.praticien_id"
            :danger="errors.praticien_id ? true : false"
            :danger-text="errors.praticien_id ? errors.praticien_id[0] : ''"
            autocomplete
            >
              <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in praticiens" />
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-button :disabled="loading ? true : false" color="primary" class="mt-2 mr-2" type="filled" @click="validatePayment()">Valider</vs-button>
          <vs-button @click="close" class="mt-2" type="border">Annuler</vs-button>
        </vs-row>
      </vs-card>
    </div>

    <div class="vx-col w-full lg:w-2/3">
      <vs-card>
        <div>
          <vs-table @selected="detail" ref="table" :max-items="10" :data="data">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
              <div>
                <div
                    @click="reload()"
                    class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
                    <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
                    <span class="ml-2 text-base text-primary">Actualiser</span>
                  </div>
              </div>
              <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                <h5>Consultations non validées</h5>
              </div>
              <div class="con-input-search vs-table--search">
                <input @keyup.enter="getSearch()" v-model="model.search" type="text" class="input-search vs-table--search-input">
                <i class="vs-icon notranslate icon-scale material-icons null">search</i>
              </div>
            </div>

            <template slot="thead">
              <vs-th>Code consultation</vs-th>
              <vs-th>Nom & prénom</vs-th>
              <vs-th>Montant payé</vs-th>
              <vs-th>Numéro payeur</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td width="20%">
                    <span class="">{{ tr.code }} </span>
                  </vs-td>

                  <vs-td width="20%">
                    <p class="product-category">{{ tr.last_name ? tr.last_name : '' }} {{ tr.first_name ? tr.first_name : '' }}</p>
                  </vs-td>

                  <vs-td width="20%">
                    <p class="product-category">{{ parseFormat(tr.amount) }}</p>
                  </vs-td>

                  <vs-td width="20%">
                    <p class="product-category">{{ tr.phone }}</p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
          <vs-pagination
            v-if="last_page && model.page"
            :total="last_page"
            v-model="model.page">
          </vs-pagination>
        </div>
      </vs-card>
    </div>
  </div>
  </div>
</template>
<script>
import { _buildQuery, format } from '../../helper/helper'
const default_model = {
  page: 1,
  namespace:'paid',
  search: ''
}
const default_form ={
  id: '',
  speciality: '',
  code: '',
  phone: '',
  praticien: '',
  first_name: '',
  last_name: '',
  type: '',
  speciality_id: '',
  praticien_id: ''
}
export default {
  data: () => ({
    last_page: 1,
    errors: [],
    item: {
      id: 0
    },
    data: [],
    model:{
      page: 1,
      namespace:'paid',
      search: '',
    },
    form:{
      id: '',
      speciality: '',
      code: '',
      phone: '',
      praticien: '',
      praticien_id: '',
      first_name: '',
      last_name: '',
      type: '',
      speciality_id: ''
    },
    specialities:[],
    types: [],
    praticiens: [],
    user: {}
  }),
  watch: {
   'model.page': function() {
     this.getData();
   }
  },
  created(){
    this.user = JSON.parse(localStorage.getItem('user_cnhu'))
  },
  mounted(){
    if (this.user.grant.validate){
      this.getData()
      this.getType()
    }
  },
  computed:{
    loading(){
      return this.form.id ? false : true
    }
  },
  methods:{
    changeSpeciality(){
      let data = this.specialities.filter(el  => el.id === this.form.speciality_id)
      if (data[0].praticien != null && data[0].praticien != ''){
        this.getPraticien(data[0].praticien)
      }
    },
    getSpecialities(){
      let data = this.types.filter(el  => el.id === this.form.type)
      if (data){
        this.form.speciality_id = ''
        data = data[0]
        this.specialities = data.specialities
        this.specialities.unshift({id: '', name: 'Selectionner'})
      }
    },
    reload(){
      this.model.page = 1
      this.model.search = ''
      this.getData()
    },
    getType() {
      this.$http
        .get("/types-specialities")
        .then((response) => {
          this.types = response.data;
          this.types.unshift({
            id: '',
            name: 'Selectionner',
            specialities: []
          })
        })
        .catch(() => {

        });
    },
    validatePayment(){
      if (confirm("Êtes-vous sûr(e) de valider ?")){
        const data = this.praticiens.find(el => el.id == this.form.praticien_id)
        this.form.praticien = data.name  ? data.name : ''
        this.$vs.loading()
        this.$http.post('payments/validate', this.form).then((response) =>{
          this.errors = []
          if (response.data.status){
            let index = this.data.indexOf(this.item)
            this.data.splice(index, 1)
            this.close()
            this.$vs.notify({
              time: 5000,
              title: 'Succès!',
              text: "Opération effectuée avec succès",
              color: 'success',
              iconPack: 'feather',
              position: 'top-right',
              icon: 'icon-check-circle'
            })
            this.$vs.loading.close()
          }else{
            this.$vs.loading.close()
            this.$vs.notify({
              time: 5000,
              title: 'Échec!',
              text: "Une erreur est survenu lors de l'opération",
              color: 'danger',
              iconPack: 'feather',
              position: 'top-right',
              icon: 'icon-x-circle'
            })
          }
        }).catch((error) => {
            this.$vs.loading.close()
            if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "page-login"})
          }else this.errors = error.response.data.errors
        })
      }
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/payments-to-validate" +_buildQuery(this.model))
        .then((response) => {
          this.data = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "page-login"})
          }
        });
    },

    getPraticien(id) {
      this.$vs.loading();
      this.$http
        .post("/praticiens/where", {id: id})
        .then((response) => {
          this.praticiens = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "page-login"})
          }
        });
    },

    parseFormat(amount){
      return format(amount)
    },
    getSearch() {
      this.model.page = 1
      this.getData()
    },
    reload(){
      this.model = { ...default_model }
      this.getData()
    },
    detail(element){
      if (this.item.id != element.id){
        this.$vs.loading();
        this.item = element
        let { id, code, phone} = { ...element }
        this.form.id = id
        this.form.code = code
        this.form.phone = phone

        this.$http
        .post("/identify/cart", {phone: element.phone, service: element.service})
        .then((response) => {
          const res = response.data.content
          if (res.resultStatus == "OPERATION_STATUS_FAILED"){
            this.$vs.notify({
              title: 'Erreur',
              text: 'Impossible de récupérer l\'identité de ce numéro',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
          }else{
            this.form.first_name = res.details.firstName
            this.form.last_name = res.details.lastName
          }
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "page-login"})
          }
        });
      }
    },
    close(){
      this.item = { id: 0 }
      this.form = { ...default_form }
      this.praticiens = []
      this.errors = []
    }
  }
}
</script>
